module.exports = __webpack_public_path__ + "static/security-9f41109d90abb58459d044e1057509e5.svg";